import { toast } from "sonner";

// URL della piattaforma pronta per pubblicare: Instagram e TikTok NON hanno una
// share-intent web che precompili il testo — il testo e' gia' negli appunti
// (pronto da incollare) e si apre direttamente l'app/sito (su mobile si apre l'app).
// Discord apre i messaggi diretti.
export function socialShareUrl(platform, siteUrl) {
  switch (platform) {
    case "instagram":
      return "https://www.instagram.com/";
    case "tiktok":
      return "https://www.tiktok.com/upload";
    case "discord":
      return "https://discord.com/channels/@me";
    default:
      return null;
  }
}

// Copia il testo della condivisione e apre la pagina del social pronta per pubblicare
export async function openSocialShare(platform, { full, openingMsg, siteUrl }) {
  try {
    await navigator.clipboard.writeText(full);
  } catch { /* clipboard non disponibile */ }
  const label = platform.charAt(0).toUpperCase() + platform.slice(1);
  toast.success(openingMsg ? openingMsg(label) : "Link copiato");
  window.open(socialShareUrl(platform, siteUrl), "_blank", "noopener,noreferrer");
}
